import { useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";

// Fixed, centered validation-error overlay for add/edit forms. Because it is
// position:fixed it stays visible no matter how far the user has scrolled down a
// long form, unlike a top-of-page banner or corner toast.
export function FormErrorOverlay({ message, onClose, testid = "form-error-overlay" }) {
    useEffect(() => {
        if (!message) return undefined;
        const t = setTimeout(onClose, 6000);
        return () => clearTimeout(t);
    }, [message, onClose]);

    if (!message) return null;
    return (
        <div className="fixed inset-x-0 top-0 z-[1200] flex justify-center px-4 pt-24 pointer-events-none" role="alert" data-testid={testid}>
            <div className="pointer-events-auto w-full max-w-md bg-[#1c0f0f] border-2 border-red-500 shadow-2xl shadow-red-900/50 px-4 py-3.5 flex items-start gap-3 animate-in fade-in slide-in-from-top-2 duration-200">
                <AlertTriangle className="h-5 w-5 text-red-400 shrink-0 mt-0.5" />
                <div className="flex-1 text-sm text-red-50 leading-relaxed">{message}</div>
                <button type="button" onClick={onClose} data-testid={`${testid}-close`} className="text-red-300 hover:text-white transition-colors shrink-0">
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
